import { createSlice } from "@reduxjs/toolkit";

const initialState = {

  loadingCounter: 0,
  isExtractionActive: false,
  errorModal: {
    open: false,
    message: "",
  },
};

const UISlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    startLoading(state) {
      state.loadingCounter += 1;
    },
    stopLoading(state) {
      state.loadingCounter = Math.max(0, state.loadingCounter - 1);
    },

    startExtraction(state) {
      state.isExtractionActive = true;
    },
    stopExtraction(state) {
      state.isExtractionActive = false;
    },
    showError(state, action) {
      state.errorModal.open = true;
      state.errorModal.message = action.payload || "An unexpected error occurred.";
    },
    hideError(state) {
      state.errorModal.open = false;
      state.errorModal.message = "";
    },
  },
});

export const { startLoading, stopLoading, showError, hideError, startExtraction, stopExtraction } = UISlice.actions;
export default UISlice.reducer;

